import { read as readXLSX, utils as XLSXUtils, writeFile as writeXLSXFile } from "@redoper1/xlsx-js-style";

export const MARKETING_CONTACT_COLUMNS = [
  ["email", "E-mail"],
  ["name", "Nome"],
  ["company", "Empresa"],
  ["segment", "Segmento"],
  ["phone", "Telefone"],
  ["notes", "Observações"],
  ["active", "Ativo"],
];

const normalize = (value) => String(value ?? "")
  .normalize("NFD")
  .replace(/[\u0300-\u036f]/g, "")
  .trim()
  .toLowerCase();

const headerAliases = new Map();
MARKETING_CONTACT_COLUMNS.forEach(([key, label]) => {
  headerAliases.set(normalize(key), key);
  headerAliases.set(normalize(label), key);
});
headerAliases.set("email", "email");
headerAliases.set("e mail", "email");
headerAliases.set("nome do contato", "name");
headerAliases.set("empresa cliente", "company");

const yesNo = (value) => {
  const normalized = normalize(value);
  if (["nao", "não", "false", "0", "inativo", "inativa"].includes(normalized)) return false;
  return true;
};

export const mapMarketingContactRows = (rows = []) => (Array.isArray(rows) ? rows : [])
  .map((row) => {
    const mapped = {};
    Object.entries(row || {}).forEach(([header, value]) => {
      const key = headerAliases.get(normalize(header));
      if (key) mapped[key] = value;
    });
    const email = String(mapped.email || "").trim().toLowerCase();
    if (!email) return null;
    return {
      email,
      name: String(mapped.name || "").trim(),
      company: String(mapped.company || "").trim(),
      segment: String(mapped.segment || "").trim(),
      phone: String(mapped.phone || "").trim(),
      notes: String(mapped.notes || "").trim(),
      active: yesNo(mapped.active),
    };
  })
  .filter(Boolean);

export const readMarketingContactsFile = async (file) => {
  const buffer = await file.arrayBuffer();
  const workbook = readXLSX(buffer, { type: "array" });
  const sheet = workbook.Sheets[workbook.SheetNames[0]];
  return mapMarketingContactRows(XLSXUtils.sheet_to_json(sheet, { defval: "" }));
};

const exportRows = (contacts = []) => contacts.map((item) => ({
  "E-mail": item.email || "",
  "Nome": item.name || "",
  "Empresa": item.company || "",
  "Segmento": item.segment || "",
  "Telefone": item.phone || "",
  "Observações": item.notes || "",
  "Ativo": item.active === false ? "Não" : "Sim",
  "Situação": item.deliveryLabel || "",
  "Último envio": item.lastDeliveryAt || "",
}));

export const exportMarketingContacts = (contacts = []) => {
  const rows = exportRows(contacts);
  const sheet = rows.length
    ? XLSXUtils.json_to_sheet(rows)
    : XLSXUtils.aoa_to_sheet([["E-mail", "Nome", "Empresa", "Segmento", "Telefone", "Observações", "Ativo", "Situação", "Último envio"]]);
  sheet["!cols"] = [
    { wch: 34 }, { wch: 24 }, { wch: 28 }, { wch: 18 }, { wch: 18 },
    { wch: 36 }, { wch: 10 }, { wch: 22 }, { wch: 22 },
  ];
  const workbook = XLSXUtils.book_new();
  XLSXUtils.book_append_sheet(workbook, sheet, "E-mails");
  writeXLSXFile(workbook, "cadastros-email-marketing.xlsx");
};

export const downloadMarketingContactsTemplate = () => {
  const sheet = XLSXUtils.json_to_sheet([{
    "E-mail": "contato@empresa.com.br",
    "Nome": "Nome do contato",
    "Empresa": "Empresa Exemplo",
    "Segmento": "Tecnologia",
    "Telefone": "(14) 99999-9999",
    "Observações": "",
    "Ativo": "Sim",
  }]);
  sheet["!cols"] = [{ wch: 34 }, { wch: 24 }, { wch: 28 }, { wch: 18 }, { wch: 18 }, { wch: 36 }, { wch: 10 }];
  const workbook = XLSXUtils.book_new();
  XLSXUtils.book_append_sheet(workbook, sheet, "Modelo");
  writeXLSXFile(workbook, "modelo-importacao-email-marketing.xlsx");
};
